
export const NOTEABLE_TYPES = [
  {value: 'sales_support_note', label: 'Sales support note'},
  {value: 'sales_support', label: 'Sales support'},
  {value: 'sales_support_milestones', label: 'Sales support milestones'},
  {value: 'sales_support_resend_mos', label: 'Sales support resend mos'},
  {value: 'sales_support_surveys', label: 'Sales support surveys'},
  {value: 'sales_support_price_renegotiated', label: 'Sales support price renegotiated'},
  {value: 'sales_support_broker_new', label: 'Sales support broker new'},
  {value: 'sales_support_broker_update', label: 'Sales support broker update'},
  {value: 'checkout_refunds', label: 'Checkout refunds'},
  {value: 'sales_support_sale_fallen', label: 'Sales support sale fallen'},
  {value: 'strategy_to_sell', label: 'Strategy to sell'}
];
